export default __webpack_public_path__ + "media/titles/title_4_locale_sv-106f608a.png";